import { render } from "react-dom";
import React from "react";
import { BrowserRouter } from "react-router-dom";

import ServiceContext from "./utils/SocketService";
import EnquiryProvider from "./context/EnquiryContext";
import ViewProvider from "./context/ViewContext";

import Inbox from "./Inbox";
import "./Inbox.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "venuescanner-js/theme";

const queryClient = new QueryClient();

render(
  <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <EnquiryProvider>
        <ViewProvider>
          <ServiceContext />
          <BrowserRouter>
            <Inbox />
          </BrowserRouter>
        </ViewProvider>
      </EnquiryProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ThemeProvider>,
  document.getElementById("inbox")
);
